import { Foundation } from './foundation.core';

import { ResponsiveToggle } from '../../foundation.responsiveToggle';
Foundation.plugin(ResponsiveToggle, 'ResponsiveToggle');

